<script setup>
import {computed, onBeforeMount, ref, useTemplateRef} from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {onBeforeRouteLeave} from "vue-router";

const props = defineProps({
  menuOptions: { type: Array, required: true },
  buttonClass: { type: String, default: 'primary'},
  title: { type: String, default: 'Select'},
  allowMultiselect: { type: Boolean, default: false }
})

const emit = defineEmits(['update:modelValue', 'selected', 'unselected'])

const showDropdown = ref(false);
const dropdown = useTemplateRef('dropdown');
const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
}

const buttonType = computed(() => {
  return `btn-${props.buttonClass}`
})
const radiusClass = computed(() => {
  return showDropdown.value ? 'partial-rounded' : null;
})
const caretIcon = computed(() => {
  return showDropdown.value ? 'angle-down' : 'angle-right';
})

const selectedKeys = ref([]);
const selected = (option) => {
  const newKey = option.fieldName;

  if(selectedKeys.value.includes(newKey)){
    // removing
    selectedKeys.value.splice(selectedKeys.value.indexOf(newKey), 1);
    emit('unselected', option);
  }
  else {
    // adding new
    if(!props.allowMultiselect){
      selectedKeys.value = [];
    }
    selectedKeys.value.push(newKey)
    emit('selected', option);
  }

  const selectedItems = []
  props.menuOptions.forEach(m => {
    if(selectedKeys.value.includes(m.fieldName)){
      selectedItems.push(m);
    }
  });
  emit('update:modelValue', selectedItems);
}
const isOptionSelected = (option) => {
  return !!selectedKeys.value.includes(option.fieldName);
}

const handleClickOutside = (event) => {
  if (dropdown.value && !dropdown.value.contains(event.target)) {
    showDropdown.value = false;
  }
}
onBeforeMount(() => {
  document.addEventListener('click', handleClickOutside)
})
onBeforeRouteLeave(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<template>
<div ref="dropdown" class="dropdown">
  <button :class="['dropdown-btn', 'btn', 'btn-lg', buttonType, radiusClass]" @click="toggleDropdown">
    {{title}}
    <font-awesome-icon class="right-icon" :icon="caretIcon"/>
  </button>
  <ul v-if="showDropdown" class="menu-items">
    <li
      :class="['dropdown-option', {'selected': isOptionSelected(option)}]"
      v-for='option in menuOptions'
      :key='option.fieldName'
      @click="selected(option)"
    >
      {{option.title}}
      <font-awesome-icon v-if="isOptionSelected(option)" class="right-icon checkmark" icon="check"/>
    </li>
  </ul>
</div>
</template>

<style scoped>
.dropdown {
  width: 100%;
}
.partial-rounded {
  border-radius: 0.3rem 0.3rem 0 0;
}
.dropdown-btn {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  position: relative;
  width: 100%;
  height: 3rem;
}
.right-icon {
  margin-left: auto;
}
.menu-items {
  border: 1px solid lightgrey;
  border-top: none;
  border-radius: 0 0 0.3rem 0.3rem;
  padding: 0;
  background-color: #FFFFFF;
  position: absolute;
  top: 3rem;
  left: 0;
  right: 0;
  z-index: 5;
}
.checkmark {
  color: #006060;
}
.dropdown-option {
  border-bottom: 1px solid lightgrey;
  list-style-type: none;
  padding: 0.5rem;
  display: flex;
  align-items: center;
}
.dropdown-option:last-child {
  border-bottom: none;
}
.dropdown-option:hover {
  background-color: #d3ebeb;
  cursor: pointer;
}
.selected {
  color: darkgrey;
}
</style>